// extracted by mini-css-extract-plugin
export default {"container":"OhCanceledButton_container__WbAt+"};